import{defineMessages}from'react-intl';

export default defineMessages({
label_brand:{
id:'i18n.brand_selection.label_brand',
defaultMessage:'Brand'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9TdG9ja0xpZnRMYW5kaW5nUGFnZS9TdG9ja0xpZnRTdW1tYXJ5L0JyYW5kU2VsZWN0aW9uL0JyYW5kU2VsZWN0aW9uLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwibGFiZWxfYnJhbmQiLCJpZCIsImRlZmF1bHRNZXNzYWdlIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFTQSxjQUFULEtBQStCLFlBQS9COztBQUVBLGNBQWVBLGdCQUFlO0FBQzVCQyxZQUFhO0FBQ1hDLEdBQUksa0NBRE87QUFFWEMsZUFBZ0IsT0FGTCxDQURlLENBQWYsQ0FBZiIsImZpbGUiOiJCcmFuZFNlbGVjdGlvbi5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBsYWJlbF9icmFuZDoge1xuICAgIGlkOiAnaTE4bi5icmFuZF9zZWxlY3Rpb24ubGFiZWxfYnJhbmQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnQnJhbmQnLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/StockLiftLandingPage/StockLiftSummary/BrandSelection/BrandSelection.messages.js
// module id = 2317
// module chunks = 0